import gql from "graphql-tag";

export default gql`
  mutation InviteUser(
    $firstName: String!
    $lastName: String!
    $email: String!
    $phoneNumber: String!
    $isATechnician: Boolean!
    $companyId: ID!
    $invite: Boolean!
    $userRole: String
  ) {
    signupUser(
      firstName: $firstName
      lastName: $lastName
      email: $email
      phoneNumber: $phoneNumber
      isATechnician: $isATechnician
      companyId: $companyId
      invite: $invite
      userRole: $userRole
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/InviteUser.ts